/** Typed wrapper over fetch for /api/market/*. */

import { getJson } from "@/lib/http";
import type {
  DriftMode,
  HeatmapResponse,
  MarketIndex,
  MaxPainDriftResponse,
  OiDriftResponse,
  OptionsResponse,
  ParticipantFlowsResponse,
  StraddleResponse,
  StraddleUnderlying,
} from "@/types/market";

export const marketApi = {
  heatmap(index: MarketIndex): Promise<HeatmapResponse> {
    return getJson<HeatmapResponse>(`/api/market/heatmap?index=${index}`);
  },
  options(index: MarketIndex): Promise<OptionsResponse> {
    return getJson<OptionsResponse>(`/api/market/options?index=${index}`);
  },
  maxPainDrift(index: MarketIndex, mode: DriftMode): Promise<MaxPainDriftResponse> {
    return getJson<MaxPainDriftResponse>(`/api/market/max-pain-drift?index=${index}&mode=${mode}`);
  },
  oiDrift(index: MarketIndex, mode: DriftMode): Promise<OiDriftResponse> {
    return getJson<OiDriftResponse>(`/api/market/oi-drift?index=${index}&mode=${mode}`);
  },
  participantFlows(): Promise<ParticipantFlowsResponse> {
    return getJson<ParticipantFlowsResponse>("/api/market/participant-flows");
  },
  /** Omitted date/expiry = newest archived session, nearest expiry. */
  straddle(
    underlying: StraddleUnderlying,
    date: string | null,
    expiry: string | null,
  ): Promise<StraddleResponse> {
    const params = new URLSearchParams({ underlying });
    if (date !== null) params.set("date", date);
    if (expiry !== null) params.set("expiry", expiry);
    return getJson<StraddleResponse>(`/api/market/straddle?${params.toString()}`);
  },
};
